<template>
  <div style="margin-top: 1.25rem">
    <div class="box">
      <carousel-3d
          :autoplay="true"
          :autoplayTimeout="3000"
          :perspective="35"
          :display="5"
          :animationSpeed="1000"
          :width="920"
          :height="400"
          controlsVisible:false
          :controlsHeight="60"
      >
        <slide v-for="(item, i) in slides" :index="i" :key="i">
          <template slot-scope="obj">
            <img :src="item.src" style="height: 400px" @click="imgClick(item,obj)"/>
          </template>
        </slide>
      </carousel-3d>
    </div>

    <div style="float: right ;align-items:center;font-size: 14px ">

      <div style="display:flex;height: 25px;">
        <span style="color: red;font-weight: bold;font-size: 25px/*margin-top: 15px*/">*</span>
        <span>OCR识别准确性受到多种因素的影响，可能存在一定的误差</span>
      </div>
      <div style="display:flex"><br>
<!--        <span style="color: red;font-weight: bold;font-size: 25px/*;margin-top: 15px**/"></span>-->
<!--        <span>本office插件支持的office版本包括：<br>
          &nbsp;&nbsp;✓&nbsp; Microsoft Office 2013 64位<br>
          &nbsp;&nbsp;✓&nbsp; Microsoft Office 2016 64位<br>
          &nbsp;&nbsp;✓&nbsp; Microsoft Office 2019 64位<br>
          &nbsp;&nbsp;✓&nbsp; Microsoft Office 2021 64位<br>
          &nbsp;&nbsp;✓&nbsp; Microsoft Office 365&nbsp;&nbsp; 64位
        </span>-->
      </div>
    </div>
  </div>
</template>

<script>
import {Carousel3d, Slide} from 'vue-carousel-3d'
/* eslint-disable */
export default {
  name: 'Banner',
  components: {
    Carousel3d,
    Slide
  },
  data() {
    return {
      slides: [
        {
          title: 'parent',
          slide: 23424234234234,
          //src: "https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg"
          src: require("../assets/imgs/u11.png")
        },
        {
          title: 'parent',
          slide: 23424234234234,
          src: require("../assets/imgs/u12.png")
        },
        {
          title: 'parent',
          slide: 23424234234234,
          src: require("../assets/imgs/u13.png")
        },
        {
          title: 'parent',
          slide: 23424234234234,
          src: require("../assets/imgs/u14.png")
        },
        {
          title: 'parent',
          slide: 23424234234234,
          src: require("../assets/imgs/u15.png")
        },
        {
          title: 'parent',
          slide: 23424234234234,
          src: require("../assets/imgs/u16.png")
        },

        // {
        //   title: 'parent',
        //   slide: 23424234234234,
        //   src: "https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg"
        // },
      ]
    }
  },
  methods: {
    imgClick(data, obj) {
      //console.log(data,obj)
    }
  }
}
</script>

<style>
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n+1) {
  background-color: #d3dce6;
}
</style>